import { render, staticRenderFns } from "./MainLoading.vue?vue&type=template&id=01769fb5&scoped=true"
import script from "./MainLoading.vue?vue&type=script&lang=ts"
export * from "./MainLoading.vue?vue&type=script&lang=ts"
import style0 from "./MainLoading.vue?vue&type=style&index=0&id=01769fb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01769fb5",
  null
  
)

export default component.exports